import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-dad06003.js";
const c = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, r = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12L5.47 6.53a.75.75 0 0 1 0-1.06Z",
  clipRule: "evenodd"
}, null, -1), s = [
  r
];
function _(a, d) {
  return e(), o("svg", l, s);
}
const f = /* @__PURE__ */ n(c, [["render", _]]);
export {
  f as default
};
